// Retorna true quando o interceptor global (api.ts) já exibiu um toast para este erro
// (limite de plano / assinatura). Catches locais devem checar isto e NÃO mostrar toast
// próprio, evitando toast duplo.
export const isHandledByInterceptor = (error: any): boolean => {
  if (error?.__handledByInterceptor) return true;
  const code = error?.response?.data?.code;
  return code === 'PLAN_LIMIT_EXCEEDED' || code === 'SUBSCRIPTION_REQUIRED' || code === 'PAYMENT_PAST_DUE';
};
